import { ApplicationRef, ComponentRef, inject, Injectable, Type, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentService {
  private appRef = inject(ApplicationRef);

  private hostViewContainerRef: ViewContainerRef | null = null;
  private currentComponentRef: ComponentRef<unknown> | null = null;

  setViewContainerRef(viewContainerRef: ViewContainerRef): void {
    this.hostViewContainerRef = viewContainerRef;
  }

  clearComponent(): void {
    if(this.currentComponentRef) {
      this.appRef.detachView(this.currentComponentRef.hostView);
      this.currentComponentRef.destroy();
      this.currentComponentRef = null;
    }

    this.hostViewContainerRef?.clear();
  }

  createComponent<T>(componentType: Type<T>, inputs?: Partial<T>): ComponentRef<T> {
    if(!this.hostViewContainerRef) {
      throw new Error('You must set viewContainerRef');
    }

    this.clearComponent();

    const componentRef = this.hostViewContainerRef.createComponent(componentType);

    if(inputs) {
      Object.entries(inputs).forEach(([key, value]): void => {
        componentRef.setInput(key, value);
      });
    }

    this.currentComponentRef = componentRef;
    return componentRef;
  }
}
